/* import __COLOCATED_TEMPLATE__ from './generic-filter-market.hbs.js'; */
var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
/**
 ### Parameters
 @param {Boolean} [allowAll=false] The `allowAll` property only applies when `multiple` is `false`.
 @param {String} [radioLabelPath="displayName"] Label path for market-option-set.
 @param {Boolean} [hideIfOneValue=true] Set to `false` to show the filter when there is only one value.
 @param {Boolean} [multiple=false] Set to `true` to allow merchants to select multiple values.
 @param {Array} [values=[]] Array of the value objects.
 @param {String} [values[].displayName] Label to show in the dropdown.
 @param {Boolean} [values[].disabled] Whether the checkbox option is disabled, only applies when `multiple` is `true`.
 @param {Object|Array} [selectedValues=null] Can either be a single value or an array of values.
 @param {String} [filterName={{t "someTranslation"}}] Defines the  translation for filter type.
 @param {Action} [onChange="change"] Sets the action sent when selectedValues are changed.
 @param {Action} [onOpen=null] Action to call when the filter is opened.
 @param {Boolean} [isSearchable=false] Whether we show search bar to filter the values
 @param {Boolean} [hideSelectAllCheckbox=false] Whether the Select All checkbox is shown, only applies when `multiple` is `true`
 @param {Boolean} [disableSort=false] Whether to not use the default sorting
 @param {Boolean} [isDisabled=false] Whether interaction with the filter should be disabled.
 */

/* eslint square/no-restricted-files:"off" -- unscoped components in this folder are discouraged */

import { action, computed, set } from '@ember/object';
import { makeArray } from '@ember/array';
import { typeOf } from '@ember/utils';
import GenericFilter from '@dashboard/shared-ui/components/generic-filter';
import { inject as service } from '@ember/service';
import marketFilterDisplayValue from '@dashboard/shared-ui/utils/market-filter-display-value';
import { tracked } from '@glimmer/tracking';
function copyAsArray(value) {
  // unwrap array proxies
  let arr;
  if (value && typeOf(value.toArray) === 'function') {
    arr = value.toArray();
  } else {
    arr = value;
  }
  return [...makeArray(arr)];
}
let GenericFilterMarket = (_dec = computed('disableSort', 'multiple', 'selectedValues', 'values.@each.displayName'), _dec2 = computed('i18n', 'values.length', 'selectedValues.[]'), _dec3 = computed('selectedValues.[]', 'allValueTrigger'), (_class = class GenericFilterMarket extends GenericFilter {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "i18n", _descriptor, this);
    _initializerDefineProperty(this, "allValueTrigger", _descriptor2, this);
    // change to force a recalculation of the all row value
    // passed in
    _defineProperty(this, "radioLabelPath", 'displayName');
  }
  get displayValues() {
    let sortedValues;
    if (this.disableSort) {
      sortedValues = this.values;
    } else {
      sortedValues = [...this.values].sort((a, b) => {
        if (a.nonStandard !== b.nonStandard) {
          return a.nonStandard ? -1 : 1;
        } else if (a.inactive !== b.inactive) {
          return a.inactive ? 1 : -1;
        }
        return a.displayName.localeCompare(b.displayName);
      });
    }
    if (this.multiple) {
      // convert these objects to wrapper objects with an checked property for filter-collection and SelectAllCheckboxManagerMarket to work
      const selectedValues = copyAsArray(this.selectedValues);
      return sortedValues.map(value => ({
        value,
        checked: selectedValues.includes(value),
        label: value.displayName,
        labelSecondary: value.inactive ? this.i18n.t('common.filters.status.inactiveValue') : null,
        disabled: value.disabled
      }));
    }
    // Else we use sq-option-set, no conversion needed
    return copyAsArray(sortedValues);
  }
  get displayValue() {
    const selectedValues = copyAsArray(this.selectedValues).map(value => value.displayName);
    return marketFilterDisplayValue(selectedValues, this.values.length);
  }
  get listValue() {
    const valuesWithTrigger = copyAsArray(this.selectedValues);
    valuesWithTrigger.push({
      displayName: this.allValueTrigger
    });
    return valuesWithTrigger.map(value => value.displayName).join(',');
  }
  multipleValuesChange(event) {
    const selectedValues = new Set(this.displayValues.map(value => value.value.displayName).filter(name => event.detail.currentSelectionValues.includes(name)));

    // Converting the selected values back to the actual values that were passed in
    const paramValues = this.values.filter(value => {
      return selectedValues.has(value.displayName);
    });
    this.onChange(copyAsArray(paramValues));
  }
  recalculateAllValue() {
    if (this.allowAll) {
      set(this, 'allValueTrigger', this.allValueTrigger + 1);
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "allValueTrigger", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "displayValues", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "displayValues"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayValue", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "displayValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "listValue", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "listValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "multipleValuesChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "multipleValuesChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recalculateAllValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "recalculateAllValue"), _class.prototype)), _class));
export { GenericFilterMarket as default };